<template>
  <div :class="componentClasses">
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  gap: {
    type: String,
    default: '6',
  },
  items: {
    type: String,
    default: '',
  },
});

const componentClasses = computed(() => [
  'stk-stack',
  props.gap ? `stk-gap-${props.gap}` : '',
  props.items ? `tw-items-${props.items}` : '',
]);
</script>

<style>
.stk-stack {
  align-items: stretch;
  display: flex;
  flex-direction: column;
  justify-content: start;
}
</style>
